import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Pagination from './../shared/pagination'
import Loader from './../shared/loader'


export default {
	name: 'STNBoxtype',
	components: {
		Paginate,
		Loader,
		Pagination,

	},
	data: function() {
		return {
			// totalRows:0,
			warehousearch: '',
			// currentPage: 0,
			listBoxtypeData: [],
			listboxdata: [],
			addboxemodal: false,
			id: '',
			boxtype: '',
			searchboxtype: '',
			length: '',
			breadth: '',
			height: '',
			boxcreate: '',
			quantity: [],
			isLoading: false,
			resultCount: '',

			userid: '',
			clientsearch: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 5,
			listClientData: [],
			listWarehouseData: [],
			listWarehouseData1: [],
			// pageno: 0,
			// totalPage: 0,
			// pageLimit: 5,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			WarehouseErrr: '',
		}
	},

	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;

		this.pageno = 0;

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
		  this.getstnboxdata();
		} 

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				//this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList(1);
				this.getstnboxdata();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},

	methods: {
		// getWarehouseList(obj) {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	if (obj == 1) {
		// 		this.listWarehouseData1 = []
		// 	} else {
		// 		this.listWarehouseData = []
		// 	}
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			if (obj == 1) {
		// 				this.listWarehouseData1 = result.data.data;
		// 			} else {
		// 				this.listWarehouseData = result.data.data;
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },

		// clientSelected(obj) {
		// 	if (this.clientid != this.clientsearch && this.clientsearch != '') {
		// 		this.clientid = this.clientsearch;
		// 		//	this.listWarehouseData1 = []
		// 		this.getWarehouseList(obj);
		// 	}
		// 	if (this.clientid != this.client && this.client != '') {
		// 		this.clientid = this.client;
		// 		this.listWarehouseData = []
		// 		this.getWarehouseList();
		// 	}

		// 	this.clientid = this.clientsearch;
		// 	this.clientid = this.client;

		// 	if (this.client) {
		// 		this.getstnboxdata();
		// 	} else {
		// 		if (this.user_type == 'warehouse_user') {
		// 			this.getstnBoxtypeData();
		// 		}
		// 	}

		// },

		// warehouseSelected(obj) {
		// 	if (obj == 1) {
		// 		this.warehouseid = this.warehousearch;
		// 	} else {
		// 		this.warehouseid = this.warehouse;
		// 	}
		// },

		addNewBox() {

			this.WarehouseErrr = '';
			this.warehouse = '';
			this.listWarehouseData = [];
			this.boxcreate = "add";
			this.addboxemodal = true;
			this.boxtype = '';
			this.quantity = '';
			document.getElementById("quantity").value = '';
			this.client = '';
			// if (this.user_type == 'client_user') {
			// 	this.getWarehouseList();
			// }
			this.$validator.reset();
			this.errors.clear();
		},

		closeaddboxemodal() {
			this.quantity = '';
			this.boxtype = '';
			this.client = '';
			this.warehouse = '';
			this.addboxemodal = false;
			this.$validator.reset();
			this.errors.clear();
		},
		getstnBoxtypeSearch() {
			this.currentPage = 1;
			this.getstnBoxtypeData()
		},
		getstnBoxtypeData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.user_type == "client_user") {
				this.clientsearch = this.clientid
			}

			this.input = ({
				offset: (this.currentPage - 1) * 5,
				limit: this.pageLimit,
				id: this.id.trim(),
				boxtype: this.searchboxtype.trim(),
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse')
			})
			if (window.localStorage.getItem('selectedClient')!=='undefined') {
				if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;

				}
				this.isLoading = true

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'stnboxtypelist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				}).then(result => {
					this.listBoxtypeData = result.data.rows
					this.totalRows = result.data.count
					if (this.totalRows <= this.pageLimit) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
					}
					this.isLoading = false

				}, error => {
					console.error(error)
				})
			} else {
				this.listBoxtypeData = [];
				this.$alertify.error(this.$t('common.clientError'))
				this.totalPage = 0;
			}
		},

		getstnboxdata() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			console.log("hit",this.client)
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getstnboxtypelist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listboxdata = result.data.rows;
				}, error => {
					console.error(error)
				})
		},

		STNBoxCreation() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.user_type === 'client_user') {
				this.client = this.clientid
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			//	if (this.client !== '') {
			if (this.boxtype === '') {
				this.$alertify.error(this.$t('stnBoxType.boxTypeSelectErr'));
				return false;
			}
			//	}
			//if (this.client !== '') {
			if (this.quantity === '') {
				this.$alertify.error(this.$t('stnBoxType.quantitySelectErr'));
				return false;
			}
			//		}
			this.isLoading = true
			axios({
					method: "POST",
					url: apiUrl.api_url + "STNBoxCreation",
					data: {
						boxtype: this.boxtype,
						quantity: this.quantity,
						warehouseid: window.localStorage.getItem('selectedWarehouse'),
						clientid: JSON.parse(this.clientid),
						userid: this.userid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				}).then(responsedata => {
					this.isLoading = false
					if (responsedata.data.errorCode == 0) {
						this.addboxemodal = false;
						this.$alertify.success(this.$t('stnBoxType.boxCreatedSuccessMsg'));
						this.client = '';
						axios({
							method: "POST",
							'url': 'http://localhost:7500/api/printer/printboxbarcode',
							data: {
								formaData: responsedata.data.boxdata
							},
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						}).then(response => {
							if (response.data.code == 200) {
								this.$alertify.success(response.data.status);
							} else {
								this.$alertify.console.error('Failed to print');
							}
						})
						this.$alertify.success(response.data.msg);

						this.getstnboxdata();
					} else if (response.data.msg == -1) {
						console.log("In2");
						this.$alertify.success(response.data.msg);
						this.addboxemodal = false;
					}
					this.isLoading = false
					this.getstnboxdata();
				})
				.catch(httpException => {
					console.error("exception is:::::::::", httpException);
				});
		},

		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getstnBoxtypeData()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getstnBoxtypeData()
		},

		resetFormData() {
			this.WarehouseErr = '';
			this.ClientErr = '';
			this.searchboxtype = '';
			this.warehousearch = '';
			this.clientsearch = '';
			this.searchboxtype = '';
			this.id = '';
			this.boxtype = '';
			this.pageno = 0;
			this.client = '';
			this.totalPage = 0;
			this.totalRows = 0;
			this.listBoxtypeData = []
		},

		onSubmit: function(e) {
			this.$validator
				.validateAll()
				.then((result) => {
					// if (result) {
					this.STNBoxCreation();
					console.log("form is valid", this.model);
					//	event.target.reset();
					// } else {
					// 	console.log("errors exist", this.errors);
					// 	return false;
					// }
				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		}
	}
}





// WEBPACK FOOTER //
// ./src/views/components/stnboxtype/stnboxtype.component.js